import { createSelector } from '@ngrx/store';
import { IRootState } from '../../../root';
import { IDemographyState } from './demography.state';

export class DemographySelectors {
  static readonly demographyState = (state: IRootState): IDemographyState => {
    return state.demography as IDemographyState;
  };

  static readonly model = createSelector(DemographySelectors.demographyState, (demography: IDemographyState) => {
    return demography.model;
  });

  static readonly data = createSelector(DemographySelectors.demographyState, (demography: IDemographyState) => {
    return demography.data;
  });
}
